@layer {
  .post > :first-child {
    margin-top: 0;
  }

  .post img {
    max-width: 100%;
  }

  .post h1,
  .post h2,
  .post h3,
  .post h4,
  .post h5,
  .post h6 {
    scroll-margin-top: 1rem;
    margin: 1.5rem 0 1rem 0;
  }

  .post p,
  .post blockquote,
  .post table {
    margin: 1rem 0;
  }

  .post ul,
  .post ol,
  .post dl {
    margin: 0.25rem 0 0.5rem 0;
    padding-inline-start: 1.75rem;
  }
}

.main {
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.header-buttons {
  display: flex;
}

.header-info {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.5em 1em;
  padding: 0.75rem 1rem;
  margin: 0 0.125rem;
  border: 1px solid var(--accent);
  font-size: 1rem;
}

.header-info > dt {
  color: var(--fg-dim);
}

.back-link,
.next-link {
  align-items: center;
  padding-inline: 0.125rem;
}

.next-link {
  margin-inline-start: auto;
}
